import { render, staticRenderFns } from "./xfans_header.vue?vue&type=template&id=f86a5d66&scoped=true&"
import script from "./xfans_header.vue?vue&type=script&lang=js&"
export * from "./xfans_header.vue?vue&type=script&lang=js&"
import style0 from "./xfans_header.vue?vue&type=style&index=0&id=f86a5d66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86a5d66",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AuthUser: require('/var/jenkins_home/workspace/prod-web-xfans/components/auth/AuthUser.vue').default,AuthLoginModal: require('/var/jenkins_home/workspace/prod-web-xfans/components/auth/AuthLoginModal.vue').default,AuthFreeLoginModal: require('/var/jenkins_home/workspace/prod-web-xfans/components/auth/AuthFreeLoginModal.vue').default,AuthForgotPasswordModal: require('/var/jenkins_home/workspace/prod-web-xfans/components/auth/AuthForgotPasswordModal.vue').default,AuthFooter: require('/var/jenkins_home/workspace/prod-web-xfans/components/auth/AuthFooter.vue').default,AuthDrawer: require('/var/jenkins_home/workspace/prod-web-xfans/components/auth/AuthDrawer.vue').default})
